<template>
	<AnalyticsCard class="pl-4 pr-6 flex-centerize horizontal">
		<Row class="width-100 flex-align-center flex-justify-space-between">
			<Row class="text-area flex-align-center">
				<SIcon v-if="iconName" :name="iconName" />
				<Col class="ml-2">
					<h3 class="reg heavy">{{ title }}</h3>
					<div class="card-val">{{ value }}</div>
				</Col>
			</Row>
			<slot class="width-100" />
		</Row>
	</AnalyticsCard>
</template>
<script>
import AnalyticsCard from '@/components/Analytics/Cards/AnalyticsCard.vue';
export default {
	name: 'AnalyticsHorizontalCard',
	props: {
		title: { type: String },
		iconName: { type: String },
		value: { type: [String, Number] },
	},
	components: { AnalyticsCard },
};
</script>
<style scoped lang="scss">
.horizontal {
	min-height: 95px;
}
.card-val {
	font-size: 25px;
	font-weight: 600;
	color: var(--primary-font-color);
}
.text-area {
	min-width: 150px;
	max-width: 150px;
}
</style>
